export default __webpack_public_path__ + "static/media/partner.607ef31e.svg";